import { render, staticRenderFns } from "./PodrucjeTemeForma.vue?vue&type=template&id=2d2426e7&scoped=true&"
import script from "./PodrucjeTemeForma.vue?vue&type=script&lang=js&"
export * from "./PodrucjeTemeForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2426e7",
  null
  
)

export default component.exports